
import { Panel } from "primereact/panel";
import { TextField } from "../../../components/TextField";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import Divider from "../../../components/menu/Divider";

 
 
 
export const TRT = ({
  data
}: {
  data: any
}) => {

  const getValue = (value?: string): string => value || "Não informado";

 
  return (
    <div style={{ width: "98%" }}>
      <Panel header="TRT">
        <Panel header="Resumo">
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              <TextField
                label="Documento"
                value={getValue(data.documento)}
              />
              <TextField
                label="Código"
                value={getValue(data.codigoAutenticidade)}
              />
              <TextField
                label="Possui processos"
                value={getValue(data.possuiProcesso ? 'Sim' : 'Não')}
              />
              <TextField
                label="Data emissão"
                value={getValue(data.dataEmissao)}
              />
            </div>
            <div>
              <TextField
                label="Nome"
                value={getValue(data.nome)}
              />
              <TextField
                label="Região"
                value={getValue(data.regiao)}
              />
              <TextField
                label="Data consulta"
                value={getValue(data.regiao)}
              />
              <TextField
                label="Status"
                value={getValue(data.status)}
              />
            </div>
          </section>
        </Panel>
       <br></br>
       <Panel header="Processos">
          {data.processos.map((processo:any) => (
            <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
              <div>
                <TextField
                  label="Local"
                  value={getValue(processo.local)}
                />
              </div>
              <div>
                {processo.processo.map((p:string) => (
                  <TextField
                    label="Número processo"
                    value={getValue(p)}
                  />
                ))}
                
              </div>
            </section>
          ))}
        </Panel>
      </Panel>
    </div>
  );
};